import { Component, OnInit, ViewChild } from "@angular/core";
import { Chart } from "chart.js";
import { BehaviorSubject, forkJoin, Observable } from "rxjs";
import { TrendDataTime } from "src/app/data/trendings-data";
import { Variable } from "src/app/models/variable";
import { GeneralInfoService } from "src/app/services/general-info.service";
import { MqttControllerService } from "src/app/services/mqtt-controller.service";
import * as Highcharts from "highcharts";

@Component({
  selector: "app-grafico-puerto",
  templateUrl: "./grafico-puerto.component.html",
  styleUrls: ["./grafico-puerto.component.css"],
})
export class GraficoPuertoComponent {
  @ViewChild("bombaChartView") private chartRef;

  public bombaChart: any;
  public bombaChartDatasets = [];
  public currentDate: Date;

  variables: Variable[] = [
    {
      varName: "VAR_APP4_MOD43_DI4",
      displayName: "Detector de Hidrocarburo",
      lastValue: null,
      lastDate: null,
      isOldDate: false,
      percent: null,
      percentEmpty: null,
      valueMeters: null,
      percentInMeters: null,
    },
    {
      varName: "VAR_APP4_MOD43_DI3",
      displayName: "Pre aviso de Incendio",
      lastValue: null,
      lastDate: null,
      isOldDate: false,
      percent: null,
      percentEmpty: null,
      valueMeters: null,
      percentInMeters: null,
    },
    {
      varName: "VAR_APP4_MOD43_DI2",
      displayName: "Incendio",
      lastValue: null,
      lastDate: null,
      isOldDate: false,
      percent: null,
      percentEmpty: null,
      valueMeters: null,
      percentInMeters: null,
    },
    {
      varName: "VAR_APP4_MOD43_DI1",
      displayName: "Estado de sistema eléctrico",
      lastValue: null,
      lastDate: null,
      isOldDate: false,
      percent: null,
      percentEmpty: null,
      valueMeters: null,
      percentInMeters: null,
    },
    {
      varName: "VAR_APP4_MOD43_DI5",
      displayName: "Detector de Trinchera",
      lastValue: null,
      lastDate: null,
      isOldDate: false,
      percent: null,
      percentEmpty: null,
      valueMeters: null,
      percentInMeters: null,
    },
  ];

  constructor(
    private generalService: GeneralInfoService,
    private mqttService: MqttControllerService
  ) {}

  ngOnInit() {
    this.currentDate = new Date();
    // this.createChart();
    this.loadNotifyGraph();
    setTimeout(() => {
      this.recalculateTrend();
    }, 1200);
    this.StartRealtimeTimer();
  }

  /**
   * Genera o refresca el grafico en la vista de la pagina.
   */
  public createChart(): void {
    let timeUnit = "minute";
    let timeStep = 1; // hour

    if (this.bombaChart != null) {
      this.bombaChart.destroy();
    }

    this.bombaChart = new Chart(this.chartRef.nativeElement, {
      type: "line",
      data: {
        datasets: this.bombaChartDatasets,
      },
      options: {
        elements: {
          point: {
            radius: 0,
          },
          line: {
            tension: 0, // disables bezier curves
          },
        },

        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,

        maintainAspectRatio: false,
        legend: {
          display: true,
        },

        scales: {
          xAxes: [
            {
              display: true,
              type: "time",
              distribution: "series",
              time: {
                stepSize: timeStep,
                displayFormats: {
                  hour: "HH:mm", // Formato de 24 horas
                  day: "DD/MM",
                },
                unit: timeUnit,
              },
              ticks: {
                source: "auto",
              },
            },
          ],
          yAxes: [
            {
              id: "digital",
              position: "left",
              display: true,
              ticks: {
                max: 20,
                min: 0,
                stepSize: 1,
              },
              scaleLabel: {
                display: true,
                labelString:
                  this.generalService.GetTranslation("graficosLabels.mca"),
                fontFamily: "Roboto",
              },
            },
          ],
        },
      },
    });
  }

  public recalculateTrend() {
    let start: number;
    let end: number;

    end = new Date().getTime();
    start = end - (end % 300000) - 8 * 60 * 60 * 1000;

    const step = this.CalculateStep(start, end);

    this.bombaChartDatasets = [];
    const querys: Observable<TrendDataTime>[] = [];

    this.variables.forEach((variable) => {
      querys.push(
        this.mqttService.GetTrendingSteppedTime(
          new TrendDataTime(0, variable.varName, start, end, step, 0, [])
        )
      );
    });

    forkJoin(querys).subscribe((e) => {
      e.forEach((d) => {
        if (this.variables[0].varName === d.variable) {
          this.bombaChartDatasets.push(
            this.MakeDataset(
              d,
              this.generalService.GetTranslation(
                "graficosLabels.plantaUpperPuertoA"
              ),
              true,
              "#FF0000"
            )
          );
        } else if (this.variables[1].varName === d.variable) {
          this.bombaChartDatasets.push(
            this.MakeDataset(
              d,
              this.generalService.GetTranslation(
                "graficosLabels.plantaUpperPuertoB"
              ),
              true,
              "#0000FF"
            )
          );
        } else if (this.variables[2].varName === d.variable) {
          this.bombaChartDatasets.push(
            this.MakeDataset(
              d,
              this.generalService.GetTranslation(
                "graficosLabels.plantaUpperPuertoC"
              ),
              true,
              "#0000FF"
            )
          );
        } else if (this.variables[3].varName === d.variable) {
          this.bombaChartDatasets.push(
            this.MakeDataset(
              d,
              this.generalService.GetTranslation(
                "graficosLabels.plantaUpperPuertoD"
              ),
              true,
              "#0000FF"
            )
          );
        } else if (this.variables[4].varName === d.variable) {
          this.bombaChartDatasets.push(
            this.MakeDataset(
              d,
              this.generalService.GetTranslation(
                "graficosLabels.plantaUpperPuertoE"
              ),
              true,
              "#0000FF"
            )
          );
        }
      });

      //this.createChart();
      this.loadNotifyGraph();
    });
  }

  private CalculateStep(inicio: number, fin: number): number {
    const diff = fin - inicio;

    return 5 * 60 * 1000;
  }

  /**
   * Genera un dataset para la grafica
   * @param data Datos de trending a colocar en el dataset
   * @param name Nombre que se desea poner en la leyenda de la curva
   */
  public MakeDataset(
    data: TrendDataTime,
    name: string,
    isDigital: boolean,
    color: string
  ): any {
    const dataTemp = [];

    data.values.forEach((v) => {
      let newDate = new Date(v.t);
      dataTemp.push({ t: newDate, y: v.v });
    });
    /*
    data.values.forEach(v => {
        dataTemp.push({ 't': v.t, 'y': v.v });
    });
*/
    return {
      // label: data.variable,
      label: name,
      data: dataTemp,
      yAxisID: isDigital ? "digital" : "analog",
      borderColor: color,
      backgroundColor: color,
      fill: false,
      steppedLine: isDigital,
    };
  }

  StartRealtimeTimer() {
    setInterval(() => {
      this.recalculateTrend();
    }, 300000);
  }

  ////////////////////
  // Complex graph //
  ////////////////////

  public time = [];
  public series = [];
  public axisY = [];
  dataObs = new BehaviorSubject(null);

  processData() {
    let values = [];

    if (this.bombaChartDatasets && this.bombaChartDatasets[0]) {
      this.bombaChartDatasets.forEach((serie) => {
        let nSerie = [];
        serie.data.forEach((element) => {
          nSerie.push(element.y);
        });
        values.push({ name: serie.label, data: nSerie });
      });
      this.time = [];
      let timeArray = this.bombaChartDatasets[0];
      timeArray.data.forEach((element) => {
        let date = new Date(element.t);
        this.time.push(date.getHours() + ":" + date.getMinutes());
      });

      return { time: this.time, values: values };
    }
  }

  loadNotifyGraph() {
    this.series = [];
    this.axisY = [];
    let yAxis = 0;
    let data = this.processData();
    if (data && data.time.length > 0) {
      if (data.values.length > 0) {
        data.values.forEach((element) => {
          this.series.push({
            name: element.name,
            type: "spline",
            yAxis: yAxis,
            data: element.data,
            tooltip: {
              valueSuffix: " ",
              valueDecimals: 2,
            },
          });
        });
        this.axisY.push({
          labels: {
            format: "{value}",
            style: {
              color: Highcharts.getOptions().colors[0],
            },
          },
          title: {
            text: "ESTADO",
            style: {
              color: Highcharts.getOptions().colors[1],
            },
          },
          min: 0,
          max: 1.5,
          alignTicks: false,
          tickInterval: 0.2,
          opposite: false,
        });
        yAxis++;
      }

      this.dataObs.next({
        series: this.series,
        xAxis: this.time,
        yAxis: this.axisY,
      });
    }
  }
}
